module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "scheduler_user",
    style: ({
      'min-height': 40 * _vm.rows + 'px'
    })
  }, [_vm._l((_vm.correctEvents), function(event) {
    return _c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          zIndex: 123123123123,
          onShow: function () { return event.obj.v_has_teachers; }
        }),
        expression: "{\n                  arrow: true,\n                  zIndex: 123123123123,\n                  onShow: () => event.obj.v_has_teachers\n                }"
      }],
      key: event.obj.id,
      ref: _vm.calEvent,
      refInFor: true,
      staticClass: "day-cal__event day-cal__event__lesson",
      style: ([{
          'top': event.row * 26 + 'px'
        },
        {
          'left': event.left + 'px'
        },
        {
          'right': event.right + 'px'
        },
        {
          'height': '25px'
        }
      ]),
      attrs: {
        "content": event.obj.v_user_names,
        "aria-label": event.othersOnLesson
      }
    }, [_c('div', {
      staticClass: "day-cal__event__content"
    }, [_c('div', {
      staticClass: "day-cal__event__content__title"
    }, [_c('span', {
      staticClass: "nowrap day-cal__event__content__title__title"
    }, [_vm._v(_vm._s(event.obj.title))]), _vm._v(" "), (event.obj.v_groups.length > 0) ? _c('span', {
      staticClass: "nowrap day-cal__event__content__title__grade"
    }, [_vm._v(_vm._s(event.obj.v_group_names))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__bg",
      style: ({
        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "day-cal__event__sider",
      style: ({
        backgroundColor: event.obj.color ? event.obj.color : '#ccc'
      })
    })])])
  }), _vm._v(" "), _vm._l((_vm.userPresenceForPlacing), function(presence) {
    return _c('div', {
      key: presence.obj.id,
      staticClass: "day-cal__event work_hours",
      style: ([{
          'left': presence.left + 'px'
        },
        {
          'right': presence.right + 'px'
        }
      ])
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a2667ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DScheduler/DSchedulerItem.vue
// module id = 1633
// module chunks = 1